<template>
  <HomePage />
</template>

<script>
import HomePage from './views/Home.vue'

export default {
  name: 'App',
  components: {
    HomePage
  }
}
</script>
